/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { StyledTopControls } from './topControlsStyles';
import { EmbersTableMenuButton } from './menuButton/tableMenuButton';
import { RefreshButton } from './refreshButton/refreshButton';
import { CountText } from './countText/countText';
import { SearchAndFilterContainer } from './searchAndFilter/searchAndFilterContainer';
import { useIntl } from 'react-intl';
export function EmbersTableTopControls(props) {
  var className = props.className,
    defaultMode = props.defaultMode,
    onModeChange = props.onModeChange,
    searchOptions = props.searchOptions,
    filterOptions = props.filterOptions,
    filterRows = props.filterRows,
    locale = props.locale,
    filterValue = props.filterValue,
    onFilterChange = props.onFilterChange,
    _props$selectedCount = props.selectedCount,
    selectedCount = _props$selectedCount === void 0 ? 0 : _props$selectedCount,
    loading = props.loading,
    loadingText = props.loadingText,
    total = props.total,
    tableCollectionString = props.tableCollectionString,
    _props$actions = props.actions,
    actions = _props$actions === void 0 ? [] : _props$actions,
    maxActionNumberInView = props.maxActionNumberInView,
    customizedActions = props.customizedActions,
    onRefresh = props.onRefresh,
    mixpanelProps = props.mixpanelProps;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(StyledTopControls, {
    className: classnames('EmbersTableTopControls-root', className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "EmbersTableTopControls-SearchAndFilter"
  }, /*#__PURE__*/React.createElement(SearchAndFilterContainer, {
    defaultMode: defaultMode,
    onModeChange: onModeChange,
    searchOptions: searchOptions,
    filterOptions: filterOptions,
    filterRows: filterRows,
    locale: locale,
    filterValue: filterValue,
    onFilterChange: onFilterChange,
    mixpanelProps: mixpanelProps
  })), /*#__PURE__*/React.createElement("div", {
    className: "EmbersTableTopControls-Indicators"
  }, /*#__PURE__*/React.createElement(CountText, {
    selectedCount: selectedCount,
    total: total,
    loading: loading,
    loadingText: loadingText,
    tableCollectionString: tableCollectionString
  }), customizedActions || actions.filter(function (v) {
    return !v.hidden;
  }).length > 0 && selectedCount > 0 && /*#__PURE__*/React.createElement(EmbersTableMenuButton, {
    options: actions,
    maxActionNumberInView: maxActionNumberInView,
    onOptionClick: function onOptionClick(option) {
      var _actions$find;
      var callback = (_actions$find = actions.find(function (item) {
        return item.label === option.label;
      })) === null || _actions$find === void 0 ? void 0 : _actions$find.callback;
      callback && callback();
    }
  }), onRefresh && /*#__PURE__*/React.createElement(RefreshButton, {
    "aria-label": intl.formatMessage({
      id: 'embers.table.iconLabel.refresh',
      defaultMessage: 'Refresh table'
    }),
    onClick: function onClick() {
      var _mixpanelProps$tracke, _mixpanelProps$tracke2;
      mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke = (_mixpanelProps$tracke2 = mixpanelProps.tracker).refreshTable) === null || _mixpanelProps$tracke === void 0 || _mixpanelProps$tracke.call(_mixpanelProps$tracke2, mixpanelProps === null || mixpanelProps === void 0 ? void 0 : mixpanelProps.tableName);
      !loading && onRefresh();
    }
  })));
}